<template>
  <main class="flex-1 overflow-hidden">
    <div class="flex h-screen flex-col overflow-hidden">
      <header class="border-b bg-background p-4">
        <div class="flex items-center justify-between">
          <div>
            <h1 class="text-2xl font-bold">Alert Notifications</h1>
            <p class="text-muted-foreground">
              Configure alert rules with escalation and acknowledgment tracking
            </p>
          </div>
          <el-button
            v-if="tabId === 'alert-rules'"
            @click="handleCreateRule"
            type="primary"
            icon="el-icon-plus"
            class="h-10 px-4 py-2"
          >
            Create Alert Rule
          </el-button>
        </div>
      </header>
      <div class="flex flex-col flex-1 overflow-hidden p-6">
        <CountPanel />
        <div class="flex-1 flex flex-col">
          <AlertRules v-if="tabId === 'alert-rules'" class="flex-1" ref="alertRuleListViewRef">
            <TabsWhatsApp v-model="tabId" />
          </AlertRules>
          <AlertHistory v-else-if="tabId === 'alert-history'" class="flex-1">
            <TabsWhatsApp v-model="tabId" />
          </AlertHistory>
          <RecipientsView v-else-if="tabId === 'recipients'" class="flex-1">
            <TabsWhatsApp v-model="tabId" />
          </RecipientsView>
          <PasscodeSettings v-else-if="tabId === 'passcode'" class="flex-1">
            <TabsWhatsApp v-model="tabId" />
          </PasscodeSettings>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import CountPanel from './CountPanel.vue'
import TabsWhatsApp from './TabsWhatsApp.vue'
import AlertRules from './AlertRules.vue'
import AlertHistory from './AlertHistory.vue'
import RecipientsView from './RecipientsView.vue'
import PasscodeSettings from './PasscodeSettings.vue'

export default {
  name: 'WhatsAppAlertsPage',
  components: {
    CountPanel,
    TabsWhatsApp,
    AlertRules,
    AlertHistory,
    RecipientsView,
    PasscodeSettings
  },
  props: {
    value: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      tabId: this.value ?? 'alert-rules',
    }
  },
  methods: {
    async handleCreateRule() {
      await this.$loaderWindow({
        title: `Edit Alert Rule`,
        component: () => import('./EditWhatsAppAlert.vue'),
        width: '70%',
        showHeader: false,
        padding: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        props: {}
      })
      const alertRuleListView = this.$refs.alertRuleListViewRef
      if (alertRuleListView && alertRuleListView.refreshList) {
        await alertRuleListView.refreshList()
      }
    }
  }
}
</script>
